import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { getPendingInvitation } from './invitationContext.js';
import { getPendingLightJoin } from './modules/freemium/light/lightJoinContext.js';
import { getPendingVoteJoin } from './modules/freemium/joinContext.js';
getPendingInvitation();
getPendingLightJoin();
getPendingVoteJoin();
import ErrorBoundary from './components/ErrorBoundary.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);